import { Title } from "@components/_Revamp/Typography/Title.stories";
import { styled } from "@linaria/react";
import MainContainer from "@pages/EverGreen/Components/Container";
import { EverGreenStyle } from "@utils/Style/everGreen";
import greenTicket from "@assets/icon/evergreen-green-tick.svg";
import React, { useCallback, useEffect, useRef, useState } from "react";
import InnerContainer from "@pages/EverGreen/Components/InnerContainer";
import Lottie from "react-lottie-player";
import animate_logo_json from "@assets/images/evergreen-sl-spinner.json";
import { SCREEN_SIZE } from "@static/screen-size";
import { Tooltip } from "@pages/EverGreen/Components/Tooltip";
import Button from "@pages/EverGreen/Components/Button";
import Modal from "@components/_Revamp/Modal";
import { useHistory } from "react-router-dom";
import { ROUTE_PATH } from "@static/route-paths";
import { store } from "@redux/store";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import {
  PRODUCT_CODE_API,
  getDropDownEvergreen,
  getThrencheLimit,
  postValidateAdviser,
} from "@api/index";
import {
  IAnnualIncomeList,
  updateAnnualIncomeList,
  updateArcCode,
  updateAssignedAgentOption,
  updateFARData,
  updateFinancialAdviser,
  updateFinancialAdviserLink,
  updateNatureOfBusinessList,
  updatePEPList,
} from "@redux/slices/EVER_GREEN/step3Slice";
import { Helpers, LoadingScreen } from "@utils/helpers";
import TrenchesLimit from "@pages/EverGreen/Components/TrenchesLimit";
import {
  updataStaticData,
  updateAgreedInitialTerms,
  updateAmountRange,
  updateCountryList,
  updateTransactionId,
  updateTrenchesLimit,
} from "@redux/slices/EVER_GREEN/step1Slice";
import { CONTENT } from "@static/content";
import { PLANS_NAME } from "@static/config";
import { updateSrsBankList } from "@redux/slices/EVER_GREEN/step4Slice";
import LeftHand from "@assets/images/evergreen-left-hand.svg";
import RightHand from "@assets/images/evergreen-right-hand.svg";
import Jar from "@assets/images/evergreen-jar.svg";
import { css } from "@linaria/core";
import { Mapper } from "../Declaration/FinancialAdviser";
import { mask } from "@utils/mask";
import {
  NotificationBox,
  NotificationContent,
} from "@components/_Revamp/NotificationBox";
import close from "@assets/icon/close.svg";
import { trackOnLoad } from "@pages/EverGreen/Helpers/analyticsHelper";

function LandingPage() {
  const urlParams: URLSearchParams = Helpers.getURLSearchParams();
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const dispatch = useAvivaDispatch();
  const detectScreenWidth = () => {
    setScreenSize(window.innerWidth);
  };
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const productData = useAvivaSelector(
    (state) => state.everGreenStep1.staticData
  );
  const trenchesLimit = useAvivaSelector(
    (state) => state.everGreenStep1.TrenchesLimit
  );
  const transactionId = useAvivaSelector(
    (state) => state.everGreenStep1.transactionId
  );
  const [whichModalToShow, setWhichModalToShow] = useState<string>("");
  const [animation, setAnimation] = useState(false);
  const handleNo = useCallback((whatToShow) => {
    setShowModal(true);
    dispatch(updateAgreedInitialTerms(false));
    setWhichModalToShow(whatToShow);
  }, []);
  const handleYes = useCallback(() => {
    dispatch(updateAgreedInitialTerms(true));
    history.push(ROUTE_PATH.EVER_GREEN_QUOTATION);
  }, []);
  const closeModal = useCallback(() => {
    window.location.replace(ROUTE_PATH.EVER_GREEN_LANDING_PAGE);
    setShowModal(false);
  }, []);
  const arcValidated = useRef<boolean>(false);
  const [arcError, setArcError] = useState<boolean>(false);
  const ANIMATE_LOGO_WIDTH =
    screenSize >= SCREEN_SIZE.mobilesUp ? "415px" : "215px";
  const ANIMATE_LOGO_HEIGHT =
    screenSize >= SCREEN_SIZE.mobilesUp ? "407px" : "211px";
  const ANIMATE_LOGO_STYLES: React.CSSProperties = {
    position: "relative",
    zIndex: 1,
    opacity: 1,
    // top: ANIMATE_LOGO_TOP,
    width: ANIMATE_LOGO_WIDTH,
    height: ANIMATE_LOGO_HEIGHT,
  };
  useEffect(() => {
    // dispatch(getValidationDate());
    window.addEventListener("resize", detectScreenWidth);
    return () => {
      window.removeEventListener("resize", detectScreenWidth);
    };
  }, [screenSize]);

  useEffect(() => {
    async function fetcher() {
      const { natureOfBusinessList, PEPList } = store.getState().everGreenStep3;
      if (natureOfBusinessList?.length > 0 && PEPList?.length > 0) {
        setAnimation(true);
        return;
      } else {
        //Get dropdown list entire flow.
        try {
          LoadingScreen();
          if (!transactionId) {
            let transaction_id = crypto.randomUUID();
            dispatch(updateTransactionId(transaction_id));
          }
          const [{ data }, { data: limit }] = await Promise.all([
            getDropDownEvergreen(),
            getThrencheLimit(null, undefined),
          ]);
          if (limit && limit.trancheLimit) {
            setWhichModalToShow( "TRENCHE_LIMIT");
            setShowModal(true);
            dispatch(updateTrenchesLimit(true));
          }
          if (
            !data?.annualIncomeRange?.length ||
            data?.annualIncomeRange?.length <= 0 ||
            !data?.natureOfBusiness?.length ||
            data?.natureOfBusiness?.length <= 0 ||
            !data?.pepRelationship?.length ||
            data?.pepRelationship?.length <= 0 ||
            !data?.srsBankList?.length ||
            data?.srsBankList?.length <= 0 ||
            !data?.countryList?.length ||
            data?.countryList?.length <= 0
          ) {
            throw Error("Failed");
          } else {
            if (data?.annualIncomeRange?.length > 0) {
              const processedAnnualIncome: IAnnualIncomeList[] = [];
              data.annualIncomeRange.forEach((entry: any) => {
                const newEntry = {
                  id: entry.code,
                  value: entry.value,
                  label: entry.label,
                };
                if (newEntry.id && newEntry.label && newEntry.value) {
                  processedAnnualIncome.push(newEntry);
                }
              });
              dispatch(updateAnnualIncomeList(processedAnnualIncome));
            }
            dispatch(updatePEPList(data.pepRelationship));
            dispatch(updateNatureOfBusinessList(data.natureOfBusiness));
            dispatch(updateSrsBankList(data.srsBankList));
            dispatch(updateCountryList(data.countryList));
          }

          if (!data?.trancheData) {
            throw Error("Failed");
          } else {
            const {
              interestRate,
              policyTerm,
              premiumTerm,
              productName,
              returnRate,
              minPremiumLimit,
              maxPremiumLimit,
            } = data?.trancheData || {};
            dispatch(
              updataStaticData({
                interestRate,
                policyTerm,
                premiumTerm,
                productName,
                returnRate,
                singlifeBankNumber: productData.singlifeBankNumber,
                singlifePayeeAccount: productData.singlifePayeeAccount,
                countryList: data.countryList,
              })
            );
            if (productName) {
              document.title = document.title.replace(
                "Singlife Digital Saver",
                productName
              );
            }
            if (minPremiumLimit && maxPremiumLimit) {
              dispatch(
                updateAmountRange({
                  minimumAmountRange: minPremiumLimit,
                  maximumAmountRange: maxPremiumLimit,
                })
              );
            }
          }

          // Do the animation
        } catch {
          // TODO handle the error case
          history.push(ROUTE_PATH.EVER_GREEN_CONTACTUS);
        } finally {
          LoadingScreen(false);
          setAnimation(true);
        }
      }
    }
    fetcher();
    document.body.style.overflow = "hidden"
    sessionStorage.removeItem("policyConfirmatio");
    return ()=>{
    document.body.style.overflow = "unset"

    }
  }, []);

  useEffect(() => {
    const leftHand = document.querySelector("#left-hand") as HTMLElement;
    const rightHand = document.querySelector("#right-hand") as HTMLElement;
    const jar = document.querySelector("#jar") as HTMLElement;
    if (leftHand && !leftHand.classList.contains("leftHandAnimation")) {
      leftHand.classList.add("leftHandAnimation");
    }
    if (rightHand && !rightHand.classList.contains("rightHandAnimation")) {
      rightHand.classList.add("rightHandAnimation");
    }
    if (jar && !jar.classList.contains("jarAnimation")) {
      jar.classList.add("jarAnimation");
    }
    return () => {
      const leftHand = document.querySelector("#left-hand") as HTMLElement;
      const rightHand = document.querySelector("#right-hand") as HTMLElement;
      const jar = document.querySelector("#jar") as HTMLElement;
      if (leftHand && leftHand.classList.contains("leftHandAnimation")) {
        leftHand.classList.remove("leftHandAnimation");
      }
      if (rightHand && rightHand.classList.contains("rightHandAnimation")) {
        rightHand.classList.remove("rightHandAnimation");
      }
      if (jar && jar.classList.contains("jarAnimation")) {
        jar.classList.remove("jarAnimation");
      }
    };
  }, [animation]);

  useEffect(() => {
    if (trenchesLimit) {
      setWhichModalToShow("TRENCHE_LIMIT");
      setShowModal(true);
    }
  }, [trenchesLimit]);

  useEffect(() => {
    const arcCode: string = urlParams.get("arc") || "";
    const validateFarCode = async (option?: HTMLDivElement) => {
      try {
        const payload = {
          agentCode: arcCode || "",
          clientNo: "",
          loggedInUserId: 0,
          loginUser: "",
          requesterClientNumber: "",
          sourceSystem: "evergreen",
          agentSelectedType: Mapper["own-adviser"],
          customerId: null,
        };
        const { data } = await postValidateAdviser(
          arcCode,
          PRODUCT_CODE_API.EVER_GREEN,
          payload
        );
        if (
          data?.data &&
          data?.data?.fullName &&
          data?.data?.agentTerminatedFlag !== "Y"
        ) {
          //update the store
          if (data?.data?.fullName) {
            data.data.fullName = mask(data?.data?.fullName);
          }
          dispatch(updateFARData({ code: decodeURI(arcCode)?.replaceAll(" ","") || decodeURI(arcCode) }));
          dispatch(updateAssignedAgentOption("own-adviser"));
          dispatch(updateFinancialAdviser(data));
          dispatch(updateFinancialAdviserLink(true));
          dispatch(updateArcCode(arcCode))
        } else {
          setArcError(true);
        }
      } catch (e) {
        //TODO update the error screen route
        setArcError(true);
      }
    };
    if (arcCode && !arcValidated.current) {
      arcValidated.current = true;
      validateFarCode();
    }
  }, []);
    //AA on load
    useEffect(()=>{
      trackOnLoad()
    },[])
  return (
    <>
      <BGSpinner>
        <Lottie
          loop={true}
          animationData={animate_logo_json}
          play={true}
          style={ANIMATE_LOGO_STYLES}
        ></Lottie>
      </BGSpinner>
      <MainContainer noBgForContainer={true}>
        <HeaderText>
          <span>{productData.productName}</span>
        </HeaderText>
        <Title variant="title" align="left">
          Get a quote within minutes
        </Title>
        <ListedFeatures>
          <li>
            <img src={greenTicket} alt="list-icon" />
            <span>
              Enjoy guaranteed yield of{" "}
              <b>
                {productData.interestRate}% p.a.* Get back{" "}
                {productData.returnRate}% of your investment
              </b>{" "}
              at the end of {productData.policyTerm} years
            </span>
          </li>
          <li>
            <img src={greenTicket} alt="list-icon" />
            <span>
              <b>Guaranteed issuance</b> - Apply without medical checkups
            </span>
          </li>
          <li>
            <img src={greenTicket} alt="list-icon" />
            <span>
              <b>100% capital guaranteed</b> from the start of 3rd policy year
            </span>
          </li>
        </ListedFeatures>
        <Para>
          *The guaranteed yield of {productData.interestRate}% per annum upon
          maturity is based on the Life Assured surviving until the end of the
          policy term with no surrender or claims made during the entire policy
          term.
        </Para>
        <InnerContainer>
          <MidTitle>Before we start, please confirm the following:</MidTitle>
          <CondtionList>
            <li>
              I am not a{" "}
              <Tooltip
                inlineComponent={
                  <span
                    style={{
                      color: EverGreenStyle.colors.primary,
                      fontSize: EverGreenStyle.fontSize.description + "px",
                      fontWeight: 600,
                      borderBottom: "dotted 1px",
                    }}
                  >
                    U.S Person
                  </span>
                }
                title={`The term "U.S. Person" means:`}
                isIcon={false}
                inlineTextStyle={{
                  color: EverGreenStyle.colors.primary,
                  fontSize: EverGreenStyle.fontSize.description + "px",
                  fontWeight: 600,
                }}
              >
                According to the U.S. IRS, a U.S. Person refers to:
                <USToolTipStyle style={{ marginTop: "5px" }}>
                  <li>
                    An individual who is a U.S. citizen or U.S. resident alien;
                  </li>
                  <li>
                    A partnership, corporation, company, or association created
                    or organised in the United States or under the laws of the
                    United States;
                  </li>
                  <li>An estate (other than a foreign estate); or</li>
                  <li>A domestic trust</li>
                </USToolTipStyle>
              </Tooltip>{" "}
              and do not possess any of the{" "}
              <Tooltip
                inlineComponent={
                  <span
                    style={{
                      color: EverGreenStyle.colors.primary,
                      fontSize: EverGreenStyle.fontSize.description + "px",
                      fontWeight: 600,
                      borderBottom: "dotted 1px",
                    }}
                  >
                    U.S Indicia
                  </span>
                }
                title={`The term "U.S. Indicia" means:`}
                isIcon={false}
                inlineTextStyle={{
                  color: EverGreenStyle.colors.primary,
                  fontSize: EverGreenStyle.fontSize.description + "px",
                  fontWeight: 600,
                }}
              >
                <USToolTipStyle>
                  <li>
                    Identification of the Account Holder as a U.S. citizen or
                    resident
                  </li>
                  <li>Unambiguous indication of a U.S. place of birth</li>
                  <li>
                    Current U.S. mailing or residence address (including a U.S.
                    post office box)
                  </li>
                  <li>Current U.S. telephone number</li>
                  <li>
                    Standing instructions to transfer funds to an account
                    maintained in the U.S.
                  </li>
                  <li>
                    Current effective power of attorney or signatory authority
                    granted to a person with a U.S. address
                  </li>
                </USToolTipStyle>
              </Tooltip>
            </li>
            <li>I am not an undischarged bankrupt.</li>
            <li>I am the Beneficial Owner of this policy.</li>
            <li>
              I am buying the policy without any advice from a financial adviser
              representative and I take responsibility to ensure that this
              policy suits my needs.
            </li>
            <li>
              I am buying this policy without any intention of replacing my
              existing policy(ies) with Singapore Life Ltd (“Singlife”) or other
              insurers(s).
            </li>
            <li>
              I am a Singapore Resident and I have resided in Singapore for more
              than 183 days in the last 12 months.
            </li>
            <li>
              <div>
                I also declare that I meet at least two (2) of the following
                statements:
              </div>
              <ul className="sublist">
                <li>a) I am below 62 years old.</li>
                <li>b) I am proficient in both spoken and written English.</li>
                <li>
                  c) I have attained at least a GCE N-Level or O-Level
                  certification, or an equivalent academic qualification.
                </li>
              </ul>
            </li>
          </CondtionList>
        </InnerContainer>
        <ButtonContainer>
          <Button
            variant="secondary"
            hoverBgColor={EverGreenStyle.colors.primary}
            hoverTextColor={EverGreenStyle.colors.white}
            label="No, I do not confirm"
            onClick={() => {
              handleNo("CONSENT_DENIED");
            }}
          />
          <Button
            variant="default"
            label="Yes, I confirm"
            onClick={handleYes}
          />
        </ButtonContainer>
      </MainContainer>
      {showModal && (
        <Modal
          className={modalPadding}
          show={showModal}
          colseBtnColor={EverGreenStyle.colors.primary}
          onClose={whichModalToShow === "CONSENT_DENIED" ? () => {
            setShowModal(false);
          }:undefined}
        >
          {whichModalToShow === "CONSENT_DENIED" && (
            <>
              <Title variant="title" align="center">
                Did not meet the requirements?
              </Title>
              <Para>
                <div className="modalPara">
                  <p>Contact us for a follow-up with one of our</p>
                  <p>Financial Adviser Representatives on your application.</p>
                </div>
              </Para>
              <ButtonContainerModal>
                <Button
                  variant="secondary"
                  hoverBgColor={EverGreenStyle.colors.primary}
                  hoverTextColor={EverGreenStyle.colors.white}
                  label="Back"
                  onClick={() => {
                    setShowModal(false);
                  }}
                />
                <Button
                  variant="default"
                  label="Contact us"
                  onClick={() => {
                    history.push(
                      ROUTE_PATH.EVER_GREEN_CONTACTUS + "?previous=landing"
                    );
                  }}
                />
              </ButtonContainerModal>
            </>
          )}
          {whichModalToShow === "TRENCHE_LIMIT" && (
            <TrenchesLimit closeModal={closeModal} />
          )}
        </Modal>
      )}
      {animation && (
        <HandJarContainer>
          <img id="left-hand" src={LeftHand} alt="left-pic" />
          <img id="right-hand" src={RightHand} alt="left-pic" />
          <img id="jar" src={Jar} alt="left-pic" />
        </HandJarContainer>
      )}
      {arcError ? (
        <NotificationBox className={notificationClass}>
          <NotificationContent iconFill={EverGreenStyle.colors.error.text}>
            <div>
              <div>
                <b>Incorrect adviser code.</b> Close the browser and try again
                with another code or continue without an adviser code.
              </div>
              <CloseIcon src={close} onClick={() => setArcError(false)} />
            </div>
          </NotificationContent>
        </NotificationBox>
      ) : null}
    </>
  );
}

export default LandingPage;

const BGSpinner = styled.div`
  position: absolute;
  display: none;
  transform: translate(50%, 50%);
  top: 46%;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    display: unset;
    top: unset;
    right: 38%;
  }
`;

const HandJarContainer = styled.div`
  display: none;
  @media screen and (min-width: 1358px) {
    display: unset;
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;

    img:nth-child(1) {
      position: absolute;
      top: 100px;
      transform-origin: 0% 0%;
      transform: rotate(60deg);
    }

    .leftHandAnimation {
      animation: lefttanimation 1s ease-in-out 2s forwards;
      @keyframes lefttanimation {
        0% {
          transform: rotate(60deg);
        }
        60% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(8deg);
        }
      }
    }

    img:nth-child(2) {
      transform-origin: 100% 100%;
      position: absolute;
      top: 100px;
      right: -63px;
      transform: rotate(45deg);
    }
    .rightHandAnimation {
      animation: rightAnimation 1s ease-in-out 2s forwards;

      @keyframes rightAnimation {
        0% {
          transform: rotate(45deg);
        }
        60% {
          transform: rotate(-8deg);
        }
        100% {
          transform: rotate(0deg);
        }
      }
    }
    img:nth-child(3) {
      transform-origin: 0% 0%;
      position: absolute;
      left: 5%;
      bottom: -270px;
    }
    .jarAnimation {
      animation: jaranimation 1s ease-in-out 2s forwards;

      @keyframes jaranimation {
        0% {
          bottom: -270px;
        }
        60% {
          bottom: 15px;
        }
        100% {
          bottom: 0px;
        }
      }
    }
  }
`;

const USToolTipStyle = styled.ul`
  list-style: disc;
`;

const ButtonContainer = styled.div`
  margin-top: 64px;
  margin-bottom: 100px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  button {
    cursor: pointer;
    max-width: 327px;
    width: 100%;
  }
  @media screen and (min-width: ${`${SCREEN_SIZE.mobilesUp}px`}) {
    flex-direction: row;
    button {
      cursor: pointer;
      max-width: 384px;
      width: 100%;
    }
  }
`;
const ButtonContainerModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  max-width: 424px;
  @media screen and (min-width: ${`${SCREEN_SIZE.mobilesUp}px`}) {
    flex-direction: row;
  }
`;
const HeaderText = styled.h1`
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 56px */
  letter-spacing: 0.75px;
  margin-bottom: 24px;
  span {
    color: ${EverGreenStyle.colors.primary};
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 40px;
  }
`;

const CondtionList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0px 24px;
  margin-top: 25px;
  font-size: ${EverGreenStyle.fontSize.description}px;
  font-weight: 500;
  font-style: normal;
  color: ${EverGreenStyle.colors.grey[500]};
  & > li {
    margin: 0;
    padding-bottom: 16px;
  }
  .sublist {
    list-style: none;
    margin-top: 18px;
    display: flex;
    flex-direction: column;
    li {
      margin: 0;
      padding-bottom: 16px;
    }
    li:last-child {
      padding-bottom: 0px;
    }
  }
`;
const MidTitle = styled.h3`
  text-align: center;
  font-size: 18px;
  line-height: 25.2px;
  font-weight: 600;
  color: ${EverGreenStyle.colors.grey[500]};
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    font-size: 24px;
    line-height: 33.6px;
  }
`;

const Para = styled.p<{ noMargin?: boolean }>`
  font-size: ${EverGreenStyle.fontSize.xs}px;
  font-weight: 600;
  letter-spacing: 0.18px;
  color: ${EverGreenStyle.colors.grey[1200]};
  margin-bottom: ${(props) => (props.noMargin ? "unset" : "29px")};
  .modalPara {
    width: 100%;
    text-align: center;
    margin-top: 10px;
    font-size: ${EverGreenStyle.fontSize.description}px;
    font-weight: 500;
    line-height: 22.4px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    margin-bottom: ${(props) => (props.noMargin ? "unset" : "64px")};
  }
`;

const ListedFeatures = styled.ul`
  list-style: none;
  list-style-image: url(${greenTicket});
  font-size: ${EverGreenStyle.fontSize.description}px;
  font-weight: 500;
  flex-direction: column;
  display: flex;
  gap: 14px;
  margin-bottom: 26px;
  margin-top: 24px;
  li {
    display: flex;
    align-items: center;
    gap: 16px;
    img {
      display: flex;
      align-self: start;
    }
    b {
      font-weight: 600;
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    li {
      img {
        display: unset;
        align-self: unset;
      }
    }
  }
`;

const modalPadding = css`
  .modal-body {
    padding: 24px 16px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .modal-body {
      padding: 36px;
    }
  }
`;

const notificationClass = css`
  width: unset;
  border-radius: 16px;
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 5;
  font-size: 14px;
  background-color: ${EverGreenStyle.colors.error.background};
  color: ${EverGreenStyle.colors.error.text};
  font-weight: 500;
  border-left: 4px solid ${EverGreenStyle.colors.error.text};
  b {
    display: contents;
  }
  div {
    display: flex;
    gap: 8px;
    width: 100%;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    width: 450px;
    div {
      max-width: unset;
    }
  }
`;

const CloseIcon = styled.img`
  cursor: pointer;
  width: 14px;
  height: 14px;
  transform: rotate(90deg);
  transition: all 0.8s ease-out 0s;

  &:hover {
    transform: rotate(360deg);
    transition: all 1s ease-out 0s;
  }
`;
